import "./src/styles/global.css"

// Prevent 404 flash during page transitions by fading out while the new
// page bundle loads. onPreRouteUpdate fires on link click; onRouteUpdate
// fires once the new page has mounted.
export const onPreRouteUpdate = () => {
  document.getElementById("gatsby-focus-wrapper")
    ?.classList.add("is-transitioning")
}

export const onRouteUpdate = () => {
  document.getElementById("gatsby-focus-wrapper")
    ?.classList.remove("is-transitioning")
}
